module.exports = __webpack_public_path__ + "img/pickup-total-request.89045a8a.svg";